import {
  SearchSuggestionType,
  LinkTrackingData,
} from '../../../../../AnalyticsContext/LinkTracking';
import { Atom } from '../../../../icons/outlined/Atom';
import { HealthCross } from '../../../../icons/outlined/HealthCross';
import { FilterChoice } from '../../../types/FilterChoice';
import { renderLocationChoice } from '../../../types/LocationChoice';
import {
  SuggestionIcon,
  SuggestionPrimary,
  SuggestionPrimaryLight,
  SuggestionSecondary,
} from '../SuggestionStyles/SuggestionStyles.styles';
import { SuggestionTemplate } from '../SuggestionTemplate/SuggestionTemplate';

interface Props {
  filters: FilterChoice;
  trackingData: LinkTrackingData;
}

export const FilterSuggestion = ({ filters: { location, topic }, trackingData }: Props) => {
  const { treatment, specialist } = topic || {};

  return (
    <SuggestionTemplate
      trackingData={{
        ...trackingData,
        searchSuggestionType: treatment
          ? SearchSuggestionType.TOPIC
          : SearchSuggestionType.SPECIALTY,
      }}
      visual={<SuggestionIcon>{treatment ? <Atom /> : <HealthCross />}</SuggestionIcon>}
      primary={
        <>
          {location && (
            <>
              <SuggestionPrimary>{treatment ?? specialist}</SuggestionPrimary>{' '}
              <SuggestionPrimaryLight>in</SuggestionPrimaryLight>{' '}
              <SuggestionPrimary>{renderLocationChoice(location)}</SuggestionPrimary>
            </>
          )}
          {!location && (
            <>
              <SuggestionPrimary>{treatment ?? specialist}</SuggestionPrimary>{' '}
              <SuggestionPrimary>near me</SuggestionPrimary>
            </>
          )}
        </>
      }
      secondary={treatment ? <SuggestionSecondary>Topic</SuggestionSecondary> : null}
    />
  );
};
